import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const EmbedIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 22 11"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <g fill={fillColor}>
        <path d="M9.01466411,10.3504841 C9.6281043,10.6128134 10.3684632,10.3101258 10.6434536,9.72492968 L14.2183292,1.81469248 C14.3452479,1.532184 14.3452479,1.20931718 14.2394823,0.906629532 C14.1125636,0.603941884 13.8798794,0.381970942 13.5837359,0.260895883 C13.4356641,0.200358353 13.2664392,0.16 13.0972144,0.16 C12.6106928,0.16 12.1664775,0.442508471 11.9549464,0.866271179 L8.38007081,8.79668756 C8.25315215,9.07919603 8.25315215,9.40206285 8.3589177,9.7047505 C8.48583636,9.98725897 8.71852057,10.2092299 9.01466411,10.3504841 Z" />
        <path d="M17.9967884,0.565507216 C17.7649383,0.301927526 17.4277018,0.16 17.0693881,0.16 C16.7743062,0.16 16.4792242,0.261376804 16.2684514,0.443855051 C16.0155241,0.646608659 15.8679831,0.930463711 15.8469058,1.25486948 C15.8258286,1.57927526 15.931215,1.88340567 16.1419878,2.10643464 L18.9874206,5.30994164 L16.1209105,8.51344865 C15.6782876,9.00005731 15.7415194,9.75024566 16.2473742,10.1760282 C16.7532289,10.5815355 17.5541655,10.5207094 17.9757111,10.0543761 L21.5588488,6.08040535 C21.9593171,5.63434742 21.9593171,4.98553587 21.5588488,4.53947793 L17.9967884,0.565507216 Z" />
        <path d="M6.34941489,10.1760282 C6.85512441,9.75024566 6.9183381,9.00005731 6.47584227,8.51344865 L3.61015504,5.30994164 L6.47584227,2.10643464 C6.68655457,1.86313031 6.79191072,1.5589999 6.77083949,1.25486948 C6.74976826,0.930463711 6.60226965,0.646608659 6.34941489,0.443855051 C6.11763137,0.261376804 5.84370538,0.16 5.54870817,0.16 C5.19049726,0.16 4.85335759,0.301927526 4.62157406,0.565507216 L1.03946502,4.53947793 C0.639111659,4.98553587 0.639111659,5.63434742 1.03946502,6.08040535 L4.60050283,10.0543761 C5.02192743,10.5207094 5.84370538,10.5815355 6.34941489,10.1760282 Z" />
      </g>
    </g>
  </svg>
);

EmbedIcon.defaultProps = defaultProps;

export { EmbedIcon };
